(function () {

    const pageUrl = window.location.pathname;
    const reportButtonWrap = document.querySelector('.report__button-wrap');
    const removeAllButton = document.querySelector('.report__button--remove-all');
    var pageButton = document.querySelector('.page__report-builder');
    var reportWrap = document.querySelector('.report__content-wrap');
    var reportBuilderBtn = document.querySelector('.report__button--generate');
    var reportCount = document.querySelector('.report__item-count');
    var pageTitleWrap = document.querySelector('.wscc-title--large');
    var pageDesc = document.querySelector('.page__report-builder-desc');
    var pageContent = document.querySelector('.wscc-main-content');
    var count = getReportCount();
    var buttonStatus = false;
    var pageTitle;
    var reportContent;


    if (pageTitleWrap) {
        pageTitle = pageTitleWrap.innerHTML;
        if (pageTitle === 'Report Builder') {
            getAllPages();
        }
    }

    if (pageDesc) {
        pageDesc = pageDesc.innerHTML;
    }

    if (pageButton) {
        getPage();
        pageButton.addEventListener('click', function () {
            if (!buttonStatus) {
                addPage();
            } else {
                removePage(pageTitle, false);
            }
        });
    }

    if (reportBuilderBtn) {
        reportBuilderBtn.addEventListener('click', function () {
            getReport();
        });
    }

    if (reportWrap) {
        getReportCount();
    }

    if (removeAllButton) {
        removeAllButton.addEventListener('click', function () {
            removeAllPages();
        });
    }

    /**
    * Checks to see if page is already in report
    */
    function getPage() {
        jQuery.ajax({
            url: "/wp-json/report-builder/v1/page",
            type: "GET",
            data: {
                title: pageTitle
            }
        }).done(function (response) {
            reportButtonAction(response);
        }).fail((error) => console.log(error));
    }

    /**
     * Add a page to the report
     */
    function addPage() {
        reportContent = pageContent.cloneNode(true);
        var pageHeaderWrap = reportContent.querySelector('.page__header-wrap');
        var reportBuilderWrap = reportContent.querySelector('.page__report-builder-wrap');
        var callout = reportContent.querySelector('.article-callout-wrap');
        if(callout){
            reportContent.removeChild(callout);
        }
        pageHeaderWrap.removeChild(reportBuilderWrap);
        reportContent = reportContent.innerHTML;
        jQuery.ajax({
            url: "/wp-json/report-builder/v1/page",
            type: "POST",
            data: {
                title: pageTitle,
                body: reportContent,
                url: pageUrl,
                desc: pageDesc
            }
        }).done(function (response) {
            if (response) {
                count = getReportCount();
                reportButtonAction(true);
            } else {
                console.log('Unable to add page');
            }
        })
            .fail((error) => console.log(error));
    }

    /**
     * Remove a page from the report
     */
    function removePage(page, builder) {
        jQuery.ajax({
            url: "/wp-json/report-builder/v1/page",
            type: "DELETE",
            data: {
                title: page
            }
        })
            .success(function (response) {
                if (response) {
                    if (!builder) {
                        reportButtonAction(false);
                    } else {
                        getAllPages();
                        getReportCount();
                    }
                }
            })
            .fail((error) => console.log(error));
    }

    /**
     * Returns all pages in report to build the view
     */
    function getAllPages() {
        jQuery.ajax({
            url: "/wp-json/report-builder/v1/pages",
            type: "GET"
        }).success(function (response) {
            if(response){
                buildReportPagesInView(response);
            }
        }).fail((error) => console.log(error));
    }

    /**
     * Remove all pages from the report
     */
    function removeAllPages() {
        jQuery.ajax({
            url: "/wp-json/report-builder/v1/pages",
            type: "DELETE"
        }).success(function (response) {
            getReportCount();
        }).fail((error) => console.log(error));
    }

    /**
     * Get count of pages in report
     */
    function getReportCount() {
        jQuery.ajax({
            url: "/wp-json/report-builder/v1/count",
            type: "GET"
        }).done((response) => {
            if (reportCount) {
                reportCount.innerHTML = response;
                setReportCount(response);
            }
        }).fail((error) => console.log(error));
    }

    /**
     * Sets the count on the report
     * @param {*} c
     */
    function setReportCount(c) {
        count = !c ? 0 : c;
        count = c;
        if (count > 0) {
            reportButtonWrap.style.display = "flex";
        } else {
            reportButtonWrap.style.display = "none";
        }
    }

    /**
     * Builds the report
     */
    function getReport() {
        var rbLink = document.createElement('a');
        rbLink.href = "/wp-json/report-builder/v1/report";
        rbLink.download = "/wp-json/report-builder/v1/report";
        rbLink.click();
    }

    /**
     * Handles report button action
     * @param {*} addPage
     */
    function reportButtonAction(addPage) {
        if (addPage) {
            pageButton.innerHTML = "Remove From Report";
            buttonStatus = true;
            pageButton.classList.add('wscc-button--red');
            pageButton.classList.remove('wscc-button--blue');
        } else {
            pageButton.innerHTML = "Add To Report";
            buttonStatus = false;
            pageButton.classList.add('wscc-button--blue');
            pageButton.classList.remove('wscc-button--red');
        }
    }

    /**
     * Builds the report builder page content
     * @param {} pages
     */
    function buildReportPagesInView(pages) {
        var pagesWrapper = document.querySelector(".report__pages-wrap");
        pagesWrapper.innerHTML = "";
        pages.forEach(page => {
            var pageWrapper = document.createElement("DIV");
            pageWrapper.classList.add("report__page-wrap");
            var closeWrap = document.createElement("DIV");
            closeWrap.classList.add("report__content-close-wrap");
            closeWrap.id = page.title;
            for (var $i = 0; $i < 4; $i++) {
                var closeLine = document.createElement("DIV");
                closeLine.classList.add("report__content-close-line");
                closeWrap.appendChild(closeLine);
            }
            var pageTitle = document.createElement("A");
            pageTitle.classList.add("report__content-page-title")
            pageTitle.innerHTML = page.title;
            pageTitle.href = page.url;
            var pageDesc = document.createElement("DIV")
            pageDesc.classList.add("report__page-desc");
            pageDesc.innerHTML = page.desc;
            pageWrapper.appendChild(closeWrap);
            pageWrapper.appendChild(pageTitle);
            pageWrapper.appendChild(pageDesc);
            pagesWrapper.appendChild(pageWrapper);
        });
        setRemovePageListeners();
    }

    /**
     * Sets remove button page listeners
     */
    function setRemovePageListeners() {
        var pageRemoves = document.querySelectorAll('.report__content-close-wrap');

        Array.prototype.forEach.call(pageRemoves, function (page) {
            page.addEventListener("click", function (evt) {
                removePage(page.id, true);
            });
        })
    }
})();


